import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const chathistoryService = {
    fetchUserSelections,
    getGamestatHistory
};

function fetchUserSelections(classId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(`${api.chathistory.userSelections}/${classId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function getGamestatHistory(classId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(`${api.chathistory.getGameStat}/${classId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}